import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';
import GenericTemplate from '../templates/GenericTemplate';
import { Box, Grid, Button } from '@material-ui/core';
import Card from '@mui/material/Card';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';
import styled from 'styled-components';
import axios from "axios";
import { API_URL } from "../../Const";
import {
  blackboardInfo,
  blackBoardColorButtons,
  fontSizeButtons,
  fontColorButtons,
  alignmentLogos,
  charPlacementLogos,
  blackBoardDesign
} from '../../BlackBoardConst';



interface blackboard {
  blackboard_color: string;
  opacity_rate: number;
  font_size: string;
  font_color: string;
  character_alignment: string;
  character_placement: string;
}

/* ダイアログ関連*/
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* ダイアログ関連*/



const Range = styled.input.attrs({ type: 'range', min: 10, max: 100, step: 10 }) <{ value: number }>`
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: 0;
  height: 18px;
  width: 50%;
  border-radius: 40px;
  border: 1px solid #ABABAB;
  background: ${(props) =>
    `linear-gradient(to right, #7ED5D1 0%, #7ED5D1 ${props.value}%, #fff ${props.value}%, #fff 100%);`};
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    background-color:  #009A94;
    border-radius: 50%;
  }

  ::-moz-range-thumb {
    width: 18px;
    height: 18px;
    -moz-appearance: none;
    background-image: radial-gradient(circle, #f7f7fc 40%, #ff9800 45%);
    border-radius: 50%;
    background-color:  #009A94;
  }
`;




const BlackBoardCreate: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()
  const [stateBlackBoardDesign, setStateBlackBoardDesign] = useState(blackBoardDesign);
  const [stateBlackBoardColorButtons, setStateBlackBoardColorButtons] = useState(blackBoardColorButtons);
  const [rangeValue, setRangeValue] = useState(100);
  const [stateFontSizeButtons, setStateFontSizeButtons] = useState(fontSizeButtons);
  const [stateFontColorButtons, setStateFontColorButtons] = useState(fontColorButtons);
  const [stateAlignmentLogos] = useState(alignmentLogos);
  const [stateCharPlacementLogos] = useState(charPlacementLogos);
  const [loading] = useState(false);  /*スピナー処理*/
  const [open, setOpen] = useState(false);  /*ダイアログ処理*/
  const handleClose = () => setOpen(false);
  const [condition, setCondition] = useState(false);



  const handleChangeRange = (e: any) => {
    setRangeValue(e.target.value);
    setStateBlackBoardDesign(prevState => ({ ...prevState, opacity: e.target.value }));
  }

  const handleClickBlackBoardButton = (e: any) => {
    const clickedColor = e.target.name;
    const newClickedButton = stateBlackBoardColorButtons.map(colorParams => {
      const selected = colorParams.blackboardColor === clickedColor ? true : false;
      const clickedButton = { ...colorParams, selected };
      return clickedButton;
    })
    setStateBlackBoardDesign(prevState => ({ ...prevState, color: clickedColor }));
    setStateBlackBoardColorButtons(newClickedButton);
  }

  const handleChangeFontSizeButton = (e: any) => {
    const changedFontSize = e.target.id;
    const newChangedButton = stateFontSizeButtons.map(sizeParams => {
      const changed = sizeParams.id === changedFontSize ? true : false;
      const changedButton = { ...sizeParams, selected: changed };
      return changedButton;
    })
    setStateBlackBoardDesign(prevState => ({ ...prevState, fontSize: changedFontSize }));
    setStateFontSizeButtons(newChangedButton);
  }

  const handleClickFontColorButton = (e: any) => {
    const clickedFontColor = e.target.name;
    const newClickedButton = stateFontColorButtons.map(fontColorParams => {
      const selected = fontColorParams.fontColor === clickedFontColor ? true : false;
      const clickedButton = { ...fontColorParams, selected };
      return clickedButton;
    })
    setStateBlackBoardDesign(prevState => ({ ...prevState, fontColor: clickedFontColor }));
    setStateFontColorButtons(newClickedButton);
  }

  const handleClickAlignmentLogo = (e: any) => {
    setStateBlackBoardDesign(prevState => ({ ...prevState, alignment: e.target.id }))
  }

  const handleClickCharLogo = (e: any) => {
    setStateBlackBoardDesign(prevState => ({ ...prevState, placement: e.target.id }))
  }

  const handleBeforeUnloadEvent = (event: any) => {
    event.returnValue = "";
    event.preventDefault();
  }



  const initialBlackBoardDisplay = (blackboard: blackboard) => {
    const {
      blackboard_color,
      opacity_rate,
      font_size,
      font_color,
      character_alignment,
      character_placement,
    } = blackboard

    setStateBlackBoardDesign({
      'color': blackboard_color,
      'opacity': opacity_rate,
      'fontSize': font_size,
      'fontColor': font_color,
      'alignment': character_alignment,
      'placement': character_placement
    })


    /** 黒板色のフォーカス */
    const initBlackBoardColor = stateBlackBoardColorButtons.map((colorParams) => {
      const focused = colorParams.blackboardColor === blackboard_color ? true : false;
      return { ...colorParams, selected: focused }
    })
    setStateBlackBoardColorButtons(initBlackBoardColor);

    /** 透過度のValue */
    setRangeValue(opacity_rate);

    /** 文字サイズのフォーカス */
    const initFontSize = stateFontSizeButtons.map((sizeParams) => {
      const focused = sizeParams.id === font_size ? true : false;
      return { ...sizeParams, selected: focused }
    })
    setStateFontSizeButtons(initFontSize);

    /** 文字色のフォーカス */
    const initFontColor = stateFontColorButtons.map((colorParams) => {
      const focused = colorParams.fontColor === font_color ? true : false;
      return { ...colorParams, selected: focused }
    })
    setStateFontColorButtons(initFontColor);
  }

  const JSONList = JSON.parse(localStorage.getItem("datalist") || '{}');

  useEffect(() => {


    window.addEventListener("beforeunload", handleBeforeUnloadEvent, true);

    const getCompanyData = async () => {
      /** CompanyIDを取得 */
      const company_id = JSONList.company.company_id;
      openLoading()
      try {
        const result = await axios.post(
          API_URL.COMPANY_GET,
          { "company_id": company_id },
          {
            headers: { Authorization: JSONList.token.IdToken }
          });
        console.log(result);
        const blackboard = result.data.data?.blackboard;
        (blackboard !== undefined) && initialBlackBoardDisplay(blackboard);
        console.log(blackboard)
        closeLoading()

      } catch (error) {
        console.error(error);
        closeLoading()
      }
    }

    getCompanyData();

    return () => window.removeEventListener("beforeunload", handleBeforeUnloadEvent, true);
  }, [])




  /* 送信処理(Post Put) */
  const handleClickButton = async () => {
    const company_id = JSONList.company.company_id;
    const params = {
      "company_id": company_id,
      "blackboard": {
        "character_alignment": stateBlackBoardDesign.alignment,
        "character_placement": stateBlackBoardDesign.placement,
        "blackboard_color": stateBlackBoardDesign.color,
        "opacity_rate": stateBlackBoardDesign.opacity,
        "font_color": stateBlackBoardDesign.fontColor,
        "font_size": stateBlackBoardDesign.fontSize
      }
    }

    openLoading();

    try {
      const result = await axios.post(
        API_URL.BLACKBOARD_UPDATE,
        params,
        { headers: { Authorization: JSONList.token.IdToken } });
      console.log(result);
      closeLoading();
      setCondition(true);
    } catch (error) {
      console.error(error);
      closeLoading();
    }
    setOpen(true);
  }

  return (
    <GenericTemplate title='電子小黒板'>
      {/* ダイヤログ ここから */}
      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>{"変更内容を保存しました"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ color: "#fff", backgroundColor: "#1e88e5" }}
              onClick={handleClose}
            >OK</Button>
          </DialogActions>
        </Dialog>
      </div>
      {/* ダイヤログ ここまで */}

      <Prompt
        when={!condition}
        message="変更内容が変更されていません。ページ遷移してもよろしいでしょうか？"
      />



      <Box component='div' className='blackboard-contents'>

        <Grid container>
          {/* 黒板側ここから */}
          <Grid item xs={7}>
            <Box component='section' className='blackboard-section'>
              <Box component='div' className='blackboard-outer-frame'>
                <Box component='div'
                  style={{ 'opacity': stateBlackBoardDesign.opacity / 100 }}
                  className={`
                    blackboard
                    color-${stateBlackBoardDesign.color}
                    font-color-${stateBlackBoardDesign.fontColor}`}>
                  <Box
                    component='div'
                    className={
                      `blackboard-body
                       font-size-${stateBlackBoardDesign.fontSize}
                       ${stateBlackBoardDesign.color === 'white' ? 'black-border' : ''}`}>
                    {blackboardInfo.map((value) => {
                      return (
                        <Box
                          key={value.id}
                          component='div'
                          className={`blackboard-row ${stateBlackBoardDesign.color === 'white' ? 'black-border' : ''}`}>
                          <Box component='div' className={`${value.left}  ${stateBlackBoardDesign.color === 'white' ? 'black-border' : ''}`}>
                            <p className={
                              `blackboard-header
                                 alignment-${stateBlackBoardDesign.alignment}
                                 placement-${stateBlackBoardDesign.placement}`}>
                              {value.header}
                            </p>
                          </Box>
                          <Box component='div' className={value.right}>
                            <p className={
                              `blackboard-data
                                 alignment-${stateBlackBoardDesign.alignment}
                                 placement-${stateBlackBoardDesign.placement}`}>
                              {value.data}
                            </p>
                          </Box>
                        </Box>
                      )
                    })}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>

          {/* 黒板側ここまで */}

          {/* デザインパレットここから */}
          <Grid item xs={5}>
            <Card variant='outlined' className='palette-section'>
              <Grid container spacing={0}>
                <Grid item xs={12} md={12}>
                  <Box component='div' className='pallette'>
                    <Grid item xs={6} md={6}><span className='palette-text'>黒板色</span></Grid>
                    <Grid item xs={6} md={6}>
                      <div style={{ display: 'flex' }}>
                        {stateBlackBoardColorButtons.map((item) => {
                          return (
                            <React.Fragment key={item.blackboardColor}>
                              <button
                                name={item.blackboardColor}
                                onClick={handleClickBlackBoardButton}
                                className={`btn btn-base-style blackboard-${item.blackboardColor} ${item.selected ? 'selected' : ''}`}>
                              </button>
                            </React.Fragment>
                          )
                        })}
                      </div>
                    </Grid>
                  </Box>

                  <Box component='div' className='design-sort'>
                    <Grid xs={6} md={6} item><span className='palette-text'>透過度</span></Grid>
                    <Range value={rangeValue} onChange={handleChangeRange} />
                  </Box >

                  <Box component='div' className='design-sort'>
                    <Grid xs={6} md={6} item><span className='palette-text'>文字サイズ</span></Grid>
                    <Grid xs={6} md={6} item>
                      <Box component='div' className='design-wrapper'>
                        {stateFontSizeButtons.map((item) => {
                          return (
                            <React.Fragment key={item.id}>
                              <input id={item.id} type='radio' name='size' className='char-size' onChange={handleChangeFontSizeButton} />
                              <label htmlFor={item.htmlFor} className={`charLabel ${item.selected ? 'selected' : ''}`}>{item.value}</label>
                            </React.Fragment>
                          )
                        })}
                      </Box>
                    </Grid>
                  </Box>

                  <Box component='div' className='design-sort'>
                    <Grid xs={6} md={6} item><span className='palette-text'>文字色</span></Grid>
                    <Grid xs={6} md={6} item>
                      <Box component='div' className='design-wrapper'>
                        {stateFontColorButtons.map((item) => {
                          return (
                            <React.Fragment key={item.fontColor}>
                              <button
                                name={item.fontColor}
                                onClick={handleClickFontColorButton}
                                className={`btn btn-base-style font-${item.fontColor}  ${item.selected ? 'selected' : ''}`}>
                              </button>
                            </React.Fragment>
                          )
                        })}
                      </Box>
                    </Grid>
                  </Box>

                  <Box component='div' className='design-sort'>
                    <Grid xs={6} md={6} item><span className='palette-text'>文字揃え</span></Grid>
                    <Grid xs={6} md={6} item>
                      <Box component='div' className='design-wrapper'>
                        {stateAlignmentLogos.map((logo) => {
                          return (
                            <React.Fragment key={logo.value}>
                              <button className='btn' onClick={handleClickAlignmentLogo}>
                                <img src={logo.src} id={logo.value} width={30} height={30} alt={logo.alt} />
                              </button>
                            </React.Fragment>
                          )
                        })}
                      </Box>
                    </Grid>
                  </Box>

                  <Box component='div' className='design-sort'>
                    <Grid xs={6} md={6} item><span className='palette-text'>文字配置</span></Grid>
                    <Grid xs={6} md={6} item>
                      <Box component='div' className='design-wrapper'>
                        {stateCharPlacementLogos.map((logo) => {
                          return (
                            <React.Fragment key={logo.value}>
                              <button className='btn' onClick={handleClickCharLogo}>
                                <img src={logo.src} id={logo.value} width={30} height={30} alt={logo.alt} />
                              </button>
                            </React.Fragment>
                          )
                        })}
                      </Box>
                    </Grid>
                  </Box>

                </Grid>


              </Grid>
            </Card>
          </Grid>
          {/* デザインパレットここまで */}
        </Grid >

        <Box component='div' className='save-btn-container'>
          <button className='save-btn' onClick={handleClickButton} disabled={loading}>保存</button>
        </Box>


      </Box >
    </GenericTemplate >

  )
}

export default BlackBoardCreate;


